const addSpace = (acc: string) => (
  acc !== '' ? ' ' : ''
);

const CC = (...classList: Array<any>): string => classList.reduce((acc, classes) => {
  if (typeof classes === 'string') {
    return `${acc}${addSpace(acc)}${classes}`;
  }

  if (Array.isArray(classes)) {
    return `${acc}${addSpace(acc)}${CC(classes)}`;
  }

  if (typeof classes === 'object') {
    return Object.keys(classes).reduce((accObj, key) => {
      if (Array.isArray(classes[key])) {
        return `${accObj}${addSpace(accObj)}${CC(classes[key])}`;
      }

      if (classes[key]) {
        return `${accObj}${addSpace(accObj)}${key}`;
      }

      return accObj;
    }, acc)
  }

  return acc;
}, '');

export default CC;
